var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#714EF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4557 5.00023C12.3184 5.0044 12.188 5.06282 12.0923 5.16312L6.6509 10.7012L4.91008 8.92945C4.86137 8.87781 4.80302 8.83659 4.73846 8.80819C4.67389 8.77978 4.60441 8.76478 4.53408 8.76405C4.46375 8.76332 4.39398 8.77689 4.32886 8.80394C4.26375 8.831 4.20459 8.87101 4.15485 8.92163C4.10512 8.97225 4.06581 9.03246 4.03922 9.09873C4.01264 9.16501 3.99931 9.23602 4.00003 9.3076C4.00074 9.37918 4.01548 9.4499 4.04339 9.51561C4.07129 9.58132 4.1118 9.6407 4.16254 9.69028L6.27713 11.8425C6.37628 11.9433 6.51072 12 6.6509 12C6.79109 12 6.92553 11.9433 7.02467 11.8425L12.8398 5.92395C12.9162 5.84838 12.9684 5.75108 12.9895 5.6448C13.0106 5.53853 12.9997 5.42823 12.9582 5.32838C12.9167 5.22853 12.8465 5.14377 12.7568 5.08521C12.6672 5.02666 12.5622 4.99704 12.4557 5.00023Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.88530dcaa45ee7f21af7aeb1170dfdbb.svg";
export { ForwardRef as ReactComponent };